// Logica copy-light da tk-slider.js (duplicata volutamente,
// vedi spec docs/specs/2026-05-17-tk-shop-by-collection-design.md §5).
class TkShopByCollectionSlider extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.tk-shop-by-collection__list');
    this.slides = Array.from(this.querySelectorAll('.tk-shop-by-collection__slide'));
    this.prevButton = this.querySelector('[name="previous"]');
    this.nextButton = this.querySelector('[name="next"]');

    if (!this.list || this.slides.length === 0) return;

    // Spostare la sezione nell'editor riconnette la stessa istanza:
    // senza guard i listener si ri-registrano a ogni reconnect.
    if (this.initialized) return;
    this.initialized = true;

    this.prevButton?.addEventListener('click', () => this.advance(-1));
    this.nextButton?.addEventListener('click', () => this.advance(1));

    if ('onscrollend' in window) {
      this.list.addEventListener('scrollend', () => this.update());
    } else {
      let raf;
      this.list.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.update());
      });
    }

    this.slides.forEach((slide) => {
      slide.addEventListener('focusin', () => {
        slide.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });
    });

    this.update();
  }

  get visibleSlides() {
    return this.slides.filter((s) => s.offsetParent !== null);
  }

  get slideStep() {
    const visible = this.visibleSlides;
    if (visible.length < 2) return visible[0]?.clientWidth || 0;
    return visible[1].offsetLeft - visible[0].offsetLeft;
  }

  get currentIndex() {
    const step = this.slideStep;
    return step > 0 ? Math.round(this.list.scrollLeft / step) : 0;
  }

  advance(direction) {
    const target = Math.max(0, Math.min(this.slides.length - 1, this.currentIndex + direction));
    this.list.scrollTo({ left: target * this.slideStep, behavior: 'smooth' });
  }

  update() {
    const atStart = this.list.scrollLeft <= 0;
    const atEnd = this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 1;

    if (this.prevButton) this.prevButton.toggleAttribute('disabled', atStart);
    if (this.nextButton) this.nextButton.toggleAttribute('disabled', atEnd);
  }
}

if (!customElements.get('tk-shop-by-collection-slider')) {
  customElements.define('tk-shop-by-collection-slider', TkShopByCollectionSlider);
}
